export const FETCH_INTERACTIONS_STARTED = 'interactions/FETCH_INTERACTIONS_STARTED';
export const STORE_INTERACTIONS = 'interactions/STORE_INTERACTIONS';
export const SET_PARAMS = 'interactions/SET_PARAMS';
